// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-stack-detail[data-v-b55f0e82]{display:flex;justify-content:center}.container-stack-detail[data-v-b55f0e82]{max-width:1140px}.container-stack-detail__content[data-v-b55f0e82]{display:flex;flex-direction:column;gap:60px}", ""]);
// Exports
module.exports = exports;
